import React, { useReducer } from 'react';
import ClienteContext from './clienteContext';
import ClienteReducer from './clienteReducer';

import clienteAxios from '../../service/axios';

import { 
    OBTENER_CLIENTES,
    OBTENER_CLIENTE,
    AGREGAR_CLIENTE,
    ELIMINAR_CLIENTE,
    ACTUALIZAR_CLIENTE,
    OBTENER_ROLES,
    ROL_CLIENTE,
    ELIMINAR_ROL_CLIENTE,
    OBTENER_CLIENTES_SOPORTE,
    CLIENTE_ERROR,
    CLIENTE_OK,
    CLIENTE_ACTUAL,
} from 'types/context';

const ClienteState = props => {
    const initialState = {
        roles: [],
        clientes : [],
        cliente: null,
        usuarios:[],        
        formulario : false,
        errorformulario: false,        
        mensaje: null
    }

    const [ state, dispatch ] = useReducer(ClienteReducer, initialState);

    // limpia un error de validacion
    const clearErrorCliente = () => {
        dispatch({
            type: CLIENTE_ERROR,
            payload: null,
        });
    };

    const clearOkCliente = () => {
        dispatch({
            type: CLIENTE_OK,
            payload: null,
        });
    };

    // Obtener los clientes
    const obtenerClientes = async (idCliente) => {
        try {
            const resultado = await clienteAxios.get(`/clientes?clienteCreador=${idCliente}`,
                {params:
                    {   
                        tamanio:90000
                    }
                }
            );

            dispatch({
                type: OBTENER_CLIENTES,
                payload: resultado.data.clientes
            })
            return resultado.data.clientes.rows
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }            
            dispatch({
                type: CLIENTE_ERROR,
                payload: alerta
            })
            return alerta
        }
    }
    const obtenerCliente = async (idCliente) => {
        try {
            const resultado = await clienteAxios.get(`/clientes?id=${idCliente}`);
            dispatch({
                type: OBTENER_CLIENTE,
                payload: resultado.data.clientes
            })
            return resultado.data.clientes.rows
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }            
            dispatch({
                type: CLIENTE_ERROR,
                payload: alerta
            })
            return alerta
        }
    }
    // Obtener los clientes
    //TODO : Cuando se defina lo de soporte acomodar esto
    const obtenerClientesSoporte = async (idUsuario) => {
/*        try {
            const resultado = await clienteAxios.get(`/clientes/${idUsuario}`,
                {params:
                    {   desde:0,
                        limite:90000
                    }
                }
            );    
            dispatch({
                type: OBTENER_CLIENTES_SOPORTE,
                payload: resultado.data.clientes
            })
            return resultado
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }            
            dispatch({
                type: CLIENTE_ERROR,
                payload: alerta
            })
            return alerta
        }*/
    } 
    // Agregar nuevo cliente
    const agregarCliente = async cliente => {
        try {
            const resultado = await clienteAxios.post('/clientes', cliente);
            // Insertar el cliente en el state
            dispatch({
                type: AGREGAR_CLIENTE,
                payload: resultado.data.cliente
            })
            const alerta = {
                msg: "Cliente creado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: CLIENTE_OK,
                payload: alerta
            })
            return resultado.status
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            
            dispatch({
                type: CLIENTE_ERROR,
                payload: alerta
            })
        }
    }
    // Selecciona el Cliente que el usuario dio click
    const clienteActual = clienteId => {
        dispatch({
            type: CLIENTE_ACTUAL,
            payload: clienteId
        })
    }

    // Elimina un Cliente
    const eliminarCliente = async clienteId => {
        try {
            const resultado = await clienteAxios.delete(`/clientes/${clienteId}`);
            dispatch({
                type: ELIMINAR_CLIENTE,
                payload: clienteId
            });
            const alerta = {
                msg: "Cliente eliminado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: CLIENTE_OK,
                payload: alerta
            })
            return resultado.status
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            
            dispatch({
                type: CLIENTE_ERROR,
                payload: alerta
            })
        }
    }

    //TODO: le da rol soporte a un cliente, hacerlo cuando este pensado como va a ser soporte
    const rolCliente = async cliente =>{
/*         try {
            const resultado = await  clienteAxios.put(`/cliente/clienteRol/${cliente.idCliente}`, cliente);
            // Actualizo el cliente en el state
            dispatch({
                type: ROL_CLIENTE,
                payload: resultado.data.usuariosPopulados
            })
            
            const alerta = {
                msg: "Soporte concedido con exito",
                categoria: 'exito'
            }
            dispatch({
                type: CLIENTE_OK,
                payload: alerta
            })
            return resultado.status
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            
            dispatch({
                type: CLIENTE_ERROR,
                payload: alerta
            })
        } */
    }
    //TODO: le quita rol soporte a un cliente, hacerlo cuando este pensado como va a ser soporte

    const eliminarRolCliente = async cliente =>{
        /* let idCliente= cliente.idCliente
        let state={"cliente": cliente.cliente, "rol":cliente.rol}
        try {
            const resultado = await clienteAxios.delete(`/cliente/clienteRol/${idCliente}`, {data:state});
            // Actualizo el cliente en el state
            dispatch({
                type: ELIMINAR_ROL_CLIENTE,
                payload: resultado.data.usuariosPopulados
            })
            
            const alerta = {
                msg: "Soporte cancelado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: CLIENTE_OK,
                payload: alerta
            })
            return resultado.status
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            
            dispatch({
                type: CLIENTE_ERROR,
                payload: alerta
            })
        } */
    }

    // Aactualizar cliente
    const actualizarCliente = async cliente => {
        try {
            const resultado = await  clienteAxios.put(`/clientes/${cliente.id}`, cliente);
            // Actualizo el cliente en el state
            dispatch({
                type: ACTUALIZAR_CLIENTE,
                payload: resultado.data.cliente
            })
            
            const alerta = {
                msg: "Cliente editado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: CLIENTE_OK,
                payload: alerta
            })
            return resultado.status
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            
            dispatch({
                type: CLIENTE_ERROR,
                payload: alerta
            })
        }
    }
    
    // muestra un error de validacion
    const errorCliente= (msj,categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }            
        dispatch({
            type: CLIENTE_ERROR,
            payload: alerta
        })
    }
    const obtenerRoles = async () =>{
    try {
        const resultado = await clienteAxios.get(`/rol`);   
        dispatch({
            type: OBTENER_ROLES,
            payload: resultado.data.roles.rows
        })
        return resultado.data.roles.rows
    } catch (error) {
        const alerta = {
            msg: error.response.data.message,
            categoria: 'error'
        }            
        dispatch({
            type: CLIENTE_ERROR,
            payload: alerta
        })
        return alerta
    }
    }
    // muestra un error de validacion
    const okCliente= (msj,categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }            
        dispatch({
            type: CLIENTE_OK,
            payload: alerta
        })
    }

    return(
        <ClienteContext.Provider
            value={{
                roles: state.roles,
                clientes: state.clientes,
                cliente: state.cliente,
                usuarios: state.usuarios,
                formulario: state.formulario,
                errorformulario: state.errorformulario,                
                mensaje: state.mensaje,
                obtenerClientes,
                obtenerCliente,
                clearErrorCliente,
                clearOkCliente,
                agregarCliente,
                clienteActual,
                eliminarCliente,
                actualizarCliente,
                rolCliente,
                eliminarRolCliente,
                obtenerClientesSoporte,
                errorCliente,
                okCliente,
                obtenerRoles
            }}
        >{props.children}

        </ClienteContext.Provider>
    )
}
export default ClienteState;
